import { render } from "./TrafficLight.vue?vue&type=template&id=689398c9&scoped=true"
import script from "./TrafficLight.vue?vue&type=script&lang=js"
export * from "./TrafficLight.vue?vue&type=script&lang=js"

import "./TrafficLight.vue?vue&type=style&index=0&id=689398c9&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689398c9"]])

export default __exports__